<template>
  <div class="row">
    <div class="hidden-xs hidden-sm">
      <div class="web-index-top">
        <img src="@/images/indexTab.png" alt="#" class="web-top-img"/>
        <div class="web-top-center middle">
          <div class="web-center-font">{{type==1?pageTips.site_name:pageTips.site_name_en}}</div>
          <div class="web-center-bottom middle">
            <div class="web-bottom-list middle" @click="goDietary">
              <span v-if="type==1">蔬适<br/>食谱</span>
              <span v-if="type==2" style="font-size:14px;">Recipes</span>
              <span class="bottom-list-icon borderBg1" v-if="labelType==1"></span>
            </div>
            <div class="web-bottom-list middle bg1" @click="goCampaign">
              <span v-if="type==1">蔬适<br/>活动</span>
              <span v-if="type==2" style="font-size:14px;">Activities</span>
              <span class="bottom-list-icon borderBg2" v-if="labelType==2"></span>
            </div>
            <div class="web-bottom-list middle bg5" @click="goService">
              <span v-if="type==1">蔬适<br/>资讯</span>
              <span v-if="type==2" style="font-size:14px;">News</span>
              <span class="bottom-list-icon borderBg3" v-if="labelType==3"></span>
            </div>
            <div class="web-bottom-list middle bg2" @click="goSolution">
              <span v-if="type==1">蔬适<br/>方案</span>
              <span v-if="type==2" style="font-size:14px;">Solutions</span>
              <span class="bottom-list-icon borderBg4" v-if="labelType==4"></span>
            </div>
            <div class="web-bottom-list middle bg3" @click="goPartner">
              <span v-if="type==1">蔬适<br/>机构</span>
              <span v-if="type==2" style="font-size:14px;">Organizations</span>
              <span class="bottom-list-icon borderBg5" v-if="labelType==5"></span>
            </div>
            <div class="web-bottom-list middle bg4" @click="goMap">
              <span v-if="type==1">蔬适<br/>地图</span>
              <span v-if="type==2" style="font-size:14px;">Map</span>
              <span class="bottom-list-icon borderBg6" v-if="labelType==6"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-index-top">
        <div class="index-top-top">
          <img src="@/images/indexTab.png" alt="#" class="phone-top-img"/>
          <div class="phone-top-center middle">
            <div class="phone-center-font">{{type==1?pageTips.site_name:pageTips.site_name_en}}</div>
          </div>
        </div>
        <div class="phone-top-bottom spaceBetween">
          <div class="phone-center-list middle" @click="goDietary">
            <span v-if="type==1">蔬适<br/>食谱</span>
            <span v-if="type==2" style="font-size:12px;">Recipes</span>
            <span class="bottom-list-icon borderBg1" v-if="labelType==1"></span>
          </div>
            <div class="phone-center-list middle bg1" @click="goCampaign">
              <span v-if="type==1">蔬适<br/>活动</span>
              <span v-if="type==2" style="font-size:12px;">Activities</span>
              <span class="bottom-list-icon borderBg2" v-if="labelType==2"></span>
            </div>
            <div class="phone-center-list middle bg5" @click="goService">
              <span v-if="type==1">蔬适<br/>资讯</span>
              <span v-if="type==2" style="font-size:12px;">News</span>
              <span class="bottom-list-icon borderBg3" v-if="labelType==3"></span>
            </div>
            <div class="phone-center-list middle bg2" @click="goSolution">
              <span v-if="type==1">蔬适<br/>方案</span>
              <span v-if="type==2" style="font-size:12px;">Solutions</span>
              <span class="bottom-list-icon borderBg4" v-if="labelType==4"></span>
            </div>
            <div class="phone-center-list middle bg3" @click="goPartner">
              <span v-if="type==1">蔬适<br/>机构</span>
              <span v-if="type==2" style="font-size:12px;">Organizations</span>
              <span class="bottom-list-icon borderBg5" v-if="labelType==5"></span>
            </div>
            <div class="phone-center-list middle bg4" @click="goMap">
              <span v-if="type==1">蔬适<br/>地图</span>
              <span v-if="type==2" style="font-size:12px;">Map</span>
              <span class="bottom-list-icon borderBg6" v-if="labelType==6"></span>
            </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'neck',
  data () {
    return {
      type:1,
      labelType:0,
      pageTips:{}
    }
  },
  methods:{
    goDietary(){
      const vm=this
      vm.$router.push({path: '/dietary'});
    },
    goCampaign(){
      const vm=this
      vm.$router.push({path: '/campaign'});
    },
    goService(){
      const vm=this
      vm.$router.push({path: '/service'});
    },
    goSolution(){
      const vm=this
      vm.$router.push({path: '/solution'});
    },
    goPartner(){
      const vm=this
      vm.$router.push({path: '/partner'});
    },
    goMap(){
      const vm=this
      vm.$router.push({path: '/map'});
    },
    setType(num,labelType){
      const vm=this
      vm.type=num
      vm.labelType=labelType
    },
    setPageTips(pageTips){
      const vm=this
      vm.pageTips=pageTips
    }
  },
  created () {
    const vm = this;
    vm.type = localStorage.getItem('ssType') || 1
  },
}
</script>

<style scoped>
.row{
  margin: 0;
  padding: 0;
}
/**  首页banner web  **/
.web-index-top{
  width: 100%;
  height: auto;
  position: relative;
  display: inline-block;
  line-height: 0;
}
.web-top-img{
  width: 100%;
  height: auto;
  display: inline-block;
  line-height: 0;
}
.web-top-center{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.web-center-font{
  font-size: 0.5rem;
  color: #fff;
  font-family: 'huangyou';
  letter-spacing: 2px;
}
.web-center-bottom{
  position: absolute;
  bottom: -0.3125rem;
  left: 0;
  right: 0;
  height: 0.625rem;
  z-index: 99;
}
.web-bottom-list{
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin: 0 0.15625rem;
  font-size: 0.15rem;
  color: #fff;
  line-height: 1.4;
  letter-spacing: 2px;
  background: rgba(220,155,97,0.95);
  cursor: pointer;
  position: relative;
}
.bottom-list-icon{
  display: block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.borderBg1{
  border-top: 10px solid rgba(220,155,97,0.95);
}
.borderBg2{
  border-top: 10px solid rgba(112,141,75,0.95);
}
.borderBg3{
  border-top: 10px solid rgba(220,155,97,0.95);
}
.borderBg4{
  border-top: 10px solid rgba(191,107,87,0.95);
}
.borderBg5{
  border-top: 10px solid rgba(54,91,58,0.95);
}
.borderBg6{
  border-top: 10px solid rgba(146,152,67,0.95);
}


/**  首页banner phone  **/
.phone-index-top{
  width: 100%;
  height: auto;
}
.index-top-top{
  width: 100%;
  height: auto;
  position: relative;
}
.phone-top-img{
  width: 100%;
  height: auto;
}
.phone-top-center{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.phone-center-font{
  font-size: 0.8rem;
  color: #fff;
  font-weight: 600;
  letter-spacing: 2px;
}
.phone-top-bottom{
  padding: 0.2rem 0.2rem;
  height: auto;
}
.phone-center-list{
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: rgba(220,155,97,0.95);
  font-size: 0.5rem;
  color: #fff;
  text-align: center;
  line-height: 1.4;
  letter-spacing: 2px;
  font-weight: 500;
  font-family: "Helvetica", "Microsoft Yahei";
  text-shadow: 0 0 5px #ff0000, 0 0 5px #6bf403;
  margin-bottom: 0.2rem;
}
.phone-center-list{
  position: relative;
}


.view-font-label{
  color: #e4a169;
}
.bg1{
  background: rgba(112,141,75,0.95);
}
.bg2{
  background: rgba(191,107,87,0.95);
}
.bg3{
  background: rgba(54,91,58,0.95);
}
.bg4{
  background: rgba(146,152,67,0.95);
}
.bg5{
  background: #e4a169;
} 
.bg6{
  background: #e4bd69;
}
.mt1{
  margin-top: 0.3125rem;
}
</style>
